import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { CartContinueActionsGenericComponent } from './cart-continue-actions.component';
import {POSLineProductsModalModuleGeneric} from '@signature-it/ngx-catalogue/components/pos-line-products-modal';


@NgModule({
    declarations: [CartContinueActionsGenericComponent],
    imports: [
        CommonModule,
        RouterModule,
        TranslateModule,
        POSLineProductsModalModuleGeneric
    ],
    exports: [CartContinueActionsGenericComponent]
})
export class CartContinueActionsGenericModule { }
